import { pushApi } from '../../api/client';
import { Card, Chip, LoadError, Loading } from '../../components/ui';
import { plural, shortWhen } from '../../lib/format';
import { useData } from '../../lib/useData';

/** Stitch Admin → System: whether push notifications are set up, and how many devices get them. */
export function PushCard() {
  const push = useData(() => pushApi.admin(), []);
  const p = push.data;
  return (
    <Card title="Push notifications">
      {push.error ? (
        <LoadError error={push.error} retry={push.reload} />
      ) : !p ? (
        <Loading />
      ) : (
        <div className="card-body">
          <dl className="dl">
            <dt>Status</dt>
            <dd>{p.ready ? <Chip tone="ok">Set up</Chip> : <Chip tone="crit">Not ready</Chip>}</dd>
            <dt>Keys</dt>
            <dd>
              {p.keys === 'env' ? (
                'From VAPID_PUBLIC_KEY and VAPID_PRIVATE_KEY'
              ) : p.keys === 'generated' ? (
                <>
                  Made by Stitch, kept in the database{' '}
                  {p.sealed ? <Chip small tone="ok">Sealed</Chip> : <Chip small tone="warn">Not sealed: set DATA_ENCRYPTION_KEY</Chip>}
                </>
              ) : (
                <span className="muted">{p.problem ?? 'Not loaded'}</span>
              )}
              {p.keyFingerprint && <div className="mono muted">Key {p.keyFingerprint}</div>}
            </dd>
            <dt>Contact for push services</dt>
            <dd className="mono" style={{ overflowWrap: 'anywhere' }}>
              {p.subject}
            </dd>
            <dt>Devices</dt>
            <dd>{p.devices === 0 ? <span className="muted">None yet</span> : `${plural(p.devices, 'device')}, ${plural(p.people, 'person', 'people')}`}</dd>
            {p.lastSuccessAt && (
              <>
                <dt>Last sent</dt>
                <dd>{shortWhen(p.lastSuccessAt)}</dd>
              </>
            )}
            {p.lastFailureAt && (
              <>
                <dt>Last failed</dt>
                <dd>{shortWhen(p.lastFailureAt)}</dd>
              </>
            )}
          </dl>
        </div>
      )}
      <div className="card-foot">
        <span className="muted" style={{ fontSize: 13 }}>
          Nothing to set up: people turn notifications on in Your settings. For fixed keys, set VAPID_PUBLIC_KEY, VAPID_PRIVATE_KEY and VAPID_SUBJECT, then redeploy. See docs/push-and-pwa.md.
        </span>
      </div>
    </Card>
  );
}
